// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_SETTINGS = 'settings/SET_SETTINGS';
